import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import {AppMenu} from "./AppMenu";


interface HomeProps {}

interface HomeState {}

const Home: React.FC<HomeProps> = ({}) => {           
    const [formState, setFormState] = useState<HomeState>(() => {});

    const navigate = useNavigate(); 

    return(
        <>
        <div style={{width: "100%", textAlign: "left"}}>
        <AppMenu/>
        </div>        
          <div key={'PS1'} style={{ 
            flex: '1 1 calc(25% - 40px)',
            minWidth: '250px',
            height: '480px',
            background: 'linear-gradient(145deg, #1a3a5c 0%, #1e4d78 20%, #e85d1a 55%, #f5a623 80%, #ffd166 100%)',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            padding: '10px'
          }}>
            <div className='card-title'>
              Demand Management
            </div>
            <div style={{ height: 'calc(100% - 10px)' }}>
               <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                    <div className="card-grey">         
                      <ul className="card-list-grey">           
                       <li key="demand-feature1">Demand driven stock planning and assisted execution.</li>
                       <li key="demand-feature2">Goal based marketing with a focus on budget, branding and Marketing ROI.</li>
                       <li key="demand-feature3">Automated knowledge systems enable quick selection of right audience, media and channel mix.</li>
                       <li key="demand-feature4">Alerts on competition gaps and customer experience performance reviews.</li>
                       <li key="demand-feature5">Support fast realizations by coordinating till product/service delivery.</li>
                      </ul>
                      <a href="#" className="card-btn-grey" onClick={()=>{navigate("/demandmanagement");}}>More..</a>
                    </div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderTop: '1px solid #e1e1e1' }}>       
                  </div>
                </div>
            </div>
          </div>
          <div key={'PS2'} style={{ 
            flex: '1 1 calc(25% - 40px)',
            minWidth: '250px',
            height: '480px',
            background: 'linear-gradient(145deg, #1a3a5c 0%, #1e4d78 20%, #e85d1a 55%, #f5a623 80%, #ffd166 100%)',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            padding: '10px'
          }}>
            <div className='card-title'>
              Order Management
            </div>
            <div style={{ height: 'calc(100% - 10px)' }}>
               <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                    <div className="card-grey">         
                      <ul className="card-list-grey">           
                       <li key="order-feature1">Modern businesses with sophisticated supply chains demand UpToDate and intelligent information while trading.</li>
                       <li key="order-feature2">System will assist to reduce effort in RFI process while purchasing / selling products and services.</li>
                       <li key="order-feature3">Automated RFQ process including selection of suppliers and distributors aligned to your business needs.</li>
                       <li key="order-feature4">Recommend strategic partnerships which can bring capabilities and capacity with reduced capex and opex.</li>
                      </ul>
                      <a href="#" className="card-btn-grey" onClick={()=>{navigate("/ordermanagement");}}>More..</a>
                    </div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderTop: '1px solid #e1e1e1' }}>       
                  </div>
                </div>
            </div>
          </div>
          <div key={'PS3'} style={{ 
            flex: '1 1 calc(25% - 40px)',
            minWidth: '250px',
            height: '480px',
            background: 'linear-gradient(145deg, #1a3a5c 0%, #1e4d78 20%, #e85d1a 55%, #f5a623 80%, #ffd166 100%)',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            padding: '10px'
          }}>
            <div className='card-title'>
              Inventory Management
            </div>
            <div style={{ height: 'calc(100% - 10px)' }}>
               <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                    <div className="card-grey">         
                      <ul className="card-list-grey">           
                       <li key="inventory-feature1">Automated replenishment planning and control.</li>
                       <li key="inventory-feature2">Manage information on transportation and logistics facilities, capacities and availability across markets.</li>
                       <li key="inventory-feature3">Coordinate inventory movements across markets by engaging the right transportation and logistics partners.</li>
                       <li key="inventory-feature4">Support for managing different types of inventories.</li>
                       <li key="inventory-feature5">Notifications on inventory levels and performance.</li>
                      </ul>
                      <a href="#" className="card-btn-grey" onClick={()=>{navigate("/inventorymanagement");}}>More..</a>
                    </div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderTop: '1px solid #e1e1e1' }}>       
                  </div>
                </div>
            </div>
          </div>
          <div key={'PS4'} style={{ 
            flex: '1 1 calc(25% - 40px)',
            minWidth: '250px',
            height: '480px',
            background: 'linear-gradient(145deg, #1a3a5c 0%, #1e4d78 20%, #e85d1a 55%, #f5a623 80%, #ffd166 100%)',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            padding: '10px'
          }}>
            <div className='card-title'>
              Data Management
            </div>
            <div style={{ height: 'calc(100% - 10px)' }}>
               <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                    <div className="card-grey">         
                      <ul className="card-list-grey">           
                       <li key="datasolution-feature1">Flows for data processing and storage.</li>
                       <li key="datasolution-feature2">Adherence to global and regional data governance policies.</li>
                       <li key="datasolution-feature3">Industry specific data models serving analytics and AI use cases.</li>
                       <li key="datasolution-feature4">Niche solutions utilizing data aligned to our core business strategy of smart spaces and smart factories.</li>
                       <li key="datasolution-feature5">Artifacts for data intelligence and insightful actions.</li>
                       <li key="datasolution-feature6">Data security.</li>
                      </ul>
                      <a href="#" className="card-btn-grey" onClick={() => { navigate("/datamanagement"); }}>More..</a>
                    </div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderTop: '1px solid #e1e1e1' }}>       
                  </div>
                </div>
            </div>
          </div>        
        </>
    );
}

export default Home; 
